// A GSTIN embeds the 10-character PAN of the entity at positions 2-12
// (0-indexed), e.g. "29ABCDE1234F1Z5" -> PAN "ABCDE1234F".
export const getPanFromGst = (gst?: string) => {
  if (!gst || gst.length < 15) return null;
  return gst.slice(2, 12);
};
